var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFancyCornerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1187 11.468L14.0906 0.646261L3.26886 0.618182C3.15612 0.602917 3.04141 0.612054 2.9325 0.644976C2.82359 0.677897 2.72303 0.733834 2.63762 0.809C2.55221 0.884164 2.48394 0.976803 2.43745 1.08064C2.39095 1.18448 2.36731 1.2971 2.36812 1.41088C2.36894 1.52465 2.39418 1.63692 2.44216 1.74008C2.49013 1.84325 2.55971 1.9349 2.64619 2.00884C2.73266 2.08278 2.83401 2.13727 2.94338 2.16863C3.05275 2.2 3.16758 2.20749 3.28009 2.19062L11.3894 2.22431L0.64626 12.9674C0.49732 13.1164 0.413645 13.3184 0.413644 13.529C0.413645 13.7396 0.497319 13.9417 0.64626 14.0906C0.795202 14.2395 0.997211 14.3232 1.20785 14.3232C1.41848 14.3232 1.62049 14.2395 1.76943 14.0906L12.5125 3.34748L12.5462 11.4568C12.547 11.6675 12.6314 11.8693 12.781 12.0178C12.9305 12.1663 13.1329 12.2493 13.3437 12.2486C13.5544 12.2479 13.7563 12.1634 13.9048 12.0139C14.0533 11.8643 14.1363 11.6619 14.1355 11.4512L14.1187 11.468Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancyCornerIcon);
export default __webpack_public_path__ + "static/media/fancy-corner-icon.3e4b0030e78771cb79930cbe5f9b70a6.svg";
export { ForwardRef as ReactComponent };